/**
 * @file usePopper
 */
import { useEffect } from 'react';
import { useSingleton } from '@tencent/glue-react-use';
import { Popper, popperCore } from '@tencent/glue-model-popper';
export function usePopper() {
  var popper = useSingleton(function () {
    return new Popper();
  });
  useEffect(function () {
    // 必须后置react的事件绑定，否则会出现触发顺序问题
    popperCore.initPopperCoreEvent();
    return function () {
      return popper.dispose();
    };
  }, []);
  return popper;
}